import SFetch from '@app/utils/sfetch'

export default {
  destroy(url) {
    return SFetch.jsonWithAlert(url, { method: 'DELETE' }).then((data) =>
      window.Turbolinks.visit(data.redirectTo)
    )
  },
  save(url, method, body) {
    return SFetch.json(url, { method, body })
  },
}
